import api from './client';

export const submitFeedback   = (data) => api.post('/feedback', data);
export const getFeedback      = ()     => api.get('/feedback');
export const getFeedbackCount = ()     => api.get('/feedback/count');
export const markFeedbackDone = (id)   => api.put(`/feedback/${id}/done`);
export const deleteFeedback   = (id)   => api.delete(`/feedback/${id}`);
